import { useDispatch, useSelector } from 'react-redux'
import { KAKAO_SERVICE } from 'features/crux/tracker/modal/kakaoService/KakaoServiceCodes'
import Table from 'components/table/Table'
import TableCheckBox from 'components/table/TableCheckBox'
import classNames from 'classnames'
import {
  addId,
  checkAll,
  clearId,
  removeId,
} from 'features/crux/tracker/modal/kakaoService/kakaoServiceTrackSlice'
import FixedTable from 'components/table/FixedTable'

const ServiceItems = () => {
  const dispatch = useDispatch()
  const { tab, content, selected, isLoading } = useSelector(
    state => state.tracker.kakaoServiceTrack
  )
  const items = content[tab]
  const selectedItems = selected[tab]
  const allChecked =
    selectedItems.length > 0 && items.length === selectedItems.length

  const handleCheckedChange = (checked, id) => {
    if (checked) {
      dispatch(addId(id))
    } else {
      dispatch(removeId(id))
    }
  }
  const handleAllCheckedChange = checked => {
    if (checked) {
      dispatch(checkAll())
    } else {
      dispatch(clearId())
    }
  }

  return (
    <FixedTable
      caption={`${KAKAO_SERVICE[tab].text} 표`}
      loading={isLoading}
      emptyMessage={`선택 가능한 ${KAKAO_SERVICE[tab].text}가 없습니다.`}>
      <Table.Head>
        <Table.Column
          title={
            <TableCheckBox
              checked={allChecked}
              onCheckedChange={handleAllCheckedChange}
              disabled={items.length === 0}
            />
          }
          thClassName="align_c"
          width={58}
        />
        <Table.Column title={KAKAO_SERVICE[tab].text} width={358} />
        <Table.Column title="타 픽셀 &amp; SDK 연동 상태" />
      </Table.Head>
      <Table.Body>
        {items.map(({ targetKey, targetKeyDesc, trackId, serviceName }) => {
          const contains = selectedItems.includes(targetKey)
          const checkBoxId = `chk_${targetKey}`
          return (
            <Table.Row
              key={targetKey}
              rowId={targetKey}
              className={classNames({ on: contains })}>
              <td className="align_c">
                <div className="inner_tbl">
                  <TableCheckBox
                    id={checkBoxId}
                    checked={contains}
                    onCheckedChange={checked => {
                      handleCheckedChange(checked, targetKey)
                    }}
                  />
                </div>
              </td>
              <td>
                <div className="inner_tbl">
                  <p className="txt_limit">{targetKeyDesc}</p>
                </div>
              </td>
              <td>
                <div className="inner_tbl">
                  {trackId && (
                    <>
                      {serviceName}
                      <p className="fc_gray">{trackId}</p>
                    </>
                  )}
                </div>
              </td>
            </Table.Row>
          )
        })}
      </Table.Body>
    </FixedTable>
  )
}
export default ServiceItems
